import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {DBGLogoCreative} from './DBGLogo';
import reportWebVitals from './reportWebVitals';


fetch("./Spinner/SpinnerConfig.json").then((res)=>res.json()).then((data)=>{

  data.map((configFile) => {
    if (document.getElementById(configFile.DivName) !== null){
      const root = ReactDOM.createRoot(document.getElementById(configFile.DivName));

      var displayLogo = true;
      if (configFile.LogoPath === "none")
      {
        displayLogo = false;
      }
      
      root.render(
        <>
          {displayLogo === true ? 
          <>{(configFile.LogoPath !== undefined)?<div className="DBGLogoContainer"><img style={{width:"100%"}} src={configFile.LogoPath}/></div>:<DBGLogoCreative/>}</> 
          : ""}
          <App config={configFile}/>
        </>
      );
    }
    return{};
  });
  }).catch((error) => {
    console.log(error)
  });


/* 
const root = ReactDOM.createRoot(document.getElementById('DBGSpinnerApp'));
root.render(
  <React.StrictMode>
    <DBGLogoCreative/>
    <App config={config}/>
  </React.StrictMode>
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
